module.exports = __webpack_public_path__ + "static/img/background.4bbe989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/background.png
// module id = 8Nyo
// module chunks = 0